module.exports = __webpack_public_path__ + "static/media/customizer.a7f24cea.png";